module.exports = __webpack_public_path__ + "static/media/country_tv.dacaa6ac.webp";